import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSwitch,_vm._g(_vm._b({attrs:{"hide-details":_vm.hideDetails,"color":_vm.color,"label":_vm.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-switch',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }